export const getDeployHash =
  window.deployHash && typeof deployHash === "string" ? deployHash : "5";

/**
 *
 * @param source
 * @param beforeEl
 * @param async
 * @param defer
 * @returns {Promise<any> | Promise}
 */
export const loadScript = (source, beforeEl, async = true, defer = true) => {
  return new Promise((resolve, reject) => {
    if (source && typeof source === "string") {
      const src = `${source}?v=${getDeployHash}`;

      if (!document.querySelector(`script[src="${src}"]`)) {
        let script = document.createElement("script");
        const prior = beforeEl || document.getElementsByTagName("script")[0];

        script.async = async;
        script.defer = defer;

        const onloadHandler = (_, isAbort) => {
          if (
            isAbort ||
            !script.readyState ||
            /loaded|complete/.test(script.readyState)
          ) {
            script.onload = null;
            script.onreadystatechange = null;
            script = undefined;

            if (isAbort) {
              reject();
            } else {
              resolve();
            }
          }
        };

        script.onload = onloadHandler;
        script.onreadystatechange = onloadHandler;

        script.src = src;
        prior.parentNode.insertBefore(script, prior);
      } else {
        resolve();
      }
    }
  });
};

/**
 *
 * @param insertTo - selector
 * @param position - center or top
 */
export const addLoader = (insertTo, position = "center") => {
  if (insertTo && typeof insertTo === "string") {
    document.querySelector(`${insertTo}`).innerHTML = `
      <div class="Loader Loader--${position}-mode">
        <div class="Loader__inner"></div>
      </div>
    `;
  }
};

/**
 *
 * @param element - selector
 * @param marginValue - indent from the top and bottom
 * @param callback - function
 */
export const observeElement = ({
  element,
  marginValue = 400,
  callback = {},
}) => {
  if (element && typeof element === "string") {
    const targets = document.querySelectorAll(element);
    const targetsConfig = {
      rootMargin: `${marginValue}px 0px ${marginValue}px 0px`,
      threshold: 0,
    };

    const elementObserver = new IntersectionObserver((entries, self) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          self.unobserve(entry.target);
          callback(entry.target);
        }
      });
    }, targetsConfig);

    if (targets) {
      Array.prototype.slice.call(targets).forEach((target) => {
        elementObserver.observe(target);
      });
    }
  }
};

/**
 *
 * @param widgetLink - widget link :)
 * @param loader - with loader? true|false
 * @param insertLoaderTo - where you want to insert a loader (selector)
 * @param loaderPosition - center | top | custom
 * @param fn - do something
 */
export const getWidget = ({
  widgetLink,
  loader = true,
  insertLoaderTo = "",
  loaderPosition = "center",
  fn = {},
}) => {
  if (widgetLink && typeof widgetLink === "string") {
    loadScript(widgetLink)
      .then(() => {
        loader && addLoader(insertLoaderTo, loaderPosition);

        if (typeof fn === "function") fn();
      })
      .catch((error) => {
        console.log(error);
      });
  }
};

export function getScript(source, callback) {
  let script = document.createElement("script");
  const prior = document.getElementsByTagName("script")[0];
  script.async = 1;

  script.onload = script.onreadystatechange = (_, isAbort) => {
    if (
      isAbort ||
      !script.readyState ||
      /loaded|complete/.test(script.readyState)
    ) {
      script.onload = script.onreadystatechange = null;
      script = undefined;

      if (!isAbort) {
        if (callback) callback();
      }
    }
  };

  script.src = source;
  prior.parentNode.insertBefore(script, prior);
}

export function hasParent(el, parent, stopEl) {
  if (
    el.parentNode === document.documentElement ||
    el.parentNode.matches(stopEl)
  )
    return false;

  if (el.parentNode.matches(parent)) {
    return true;
  } else {
    hasParent(el.parentNode, parent);
  }
}

export function formatDate(unformattedDate) {
  var deliveredDate = new Date(),
    today = new Date(),
    MILLISECONDS_IN_ONE_DAY = 24 * 60 * 60 * 1000;

  deliveredDate.setTime(Date.parse(unformattedDate));
  today = new Date(
    today.getFullYear(),
    today.getMonth(),
    today.getDate()
  ).valueOf();

  if (deliveredDate < today - MILLISECONDS_IN_ONE_DAY) {
    return dateToYMD(deliveredDate);
  } else if (deliveredDate < today) {
    return "Yesterday";
  } else {
    return "Today";
  }
}

function dateToYMD(date) {
  const d = new Date(date);
  const year = d.getFullYear();

  let month = `${d.getMonth() + 1}`;
  let day = `${d.getDate()}`;

  if (month.length < 2) month = `0${month}`;
  if (day.length < 2) day = `0${day}`;

  return [year, month, day].join("-");
}

export function is_touch_device() {
  var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
  var mq = function (query) {
    return window.matchMedia(query).matches;
  };

  if (
    "ontouchstart" in window ||
    (window.DocumentTouch && document instanceof DocumentTouch)
  ) {
    return true;
  }

  var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
  return mq(query);
}

export const getCookie = (name) => {
  const matches = document.cookie.match(
    new RegExp(
      `(?:^|; )${`${name}`.replace(
        /([\.$?*|{}\(\)\[\]\\\/\+^])/g,
        "\\$1"
      )}=([^;]*)`
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
};
